<template>

  <div class="section d-flex">

    <div class="menu_section hidden-md-and-down"></div>
    <div class="container_section">

      <v-container>
        
        <v-breadcrumbs :items="breadcrumbs" class="pl-0 pb-0"></v-breadcrumbs>

        <h1 class="py-10">{{ device.name }}</h1>

        <Tags :device_id="parseInt(device_id)" />

      </v-container>

    </div>
    
  </div>

</template>

<script>

// import { mapGetters } from "vuex";
import Tags from '@/components/devices/Tags' ;
import { mapGetters } from "vuex";

export default {
  name: "Home",
  computed: {
      // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
          appData: "app/data",
          devices: "reporters/devices",
      })
  },
  data () {
    return {
      device_id: this.$route.params.device_id,
      device: {
        name: 'Loading'
      },
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/dashboard',
          exact: true
        },
        {
          text: 'Reporters',
          disabled: false,
          to: '/reporters',
          exact: true
        },
        {
          text: 'Loading',
          disabled: true,
          exact: true
        },
      ]
    }
  },
  methods: {
  },
  components: {
      Tags
  },
  created() {

    let _this = this ; 

    let deviceSearch = this.devices.filter(function( obj ) {
        return obj.id === parseInt(_this.device_id) ;
    });

    this.device = deviceSearch[0] ;
    this.breadcrumbs[2].text = this.device.name ;
    
  }

};
</script>
